import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const stats = [
  { value: '10K+', label: 'Professionals' },
  { value: '50K+', label: 'Clients Served' },
  { value: '20+', label: 'Service Categories' },
  { value: '4.8★', label: 'App Rating' },
];

const benefits = [
  {
    icon: '🔍',
    title: 'Find Verified Experts',
    desc: 'Every professional on AfreXpert is verified and reviewed by real clients.',
  },
  {
    icon: '📅',
    title: 'Book Instantly',
    desc: 'Schedule appointments in seconds, at any time that works for you.',
  },
  {
    icon: '💬',
    title: 'Chat in Real-time',
    desc: 'Communicate directly with your service provider before and after booking.',
  },
  {
    icon: '🛡️',
    title: 'Secure Payments',
    desc: 'Pay safely through the app with full transaction protection.',
  },
];

export default function Home() {
  return (
    <div className="home-page">
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg-pattern" />
        <div className="container hero-inner">
          <div className="hero-content">
            <span className="hero-badge">🌍 Available across Africa</span>
            <h1 className="hero-title">
              Connect with <em>Skilled Experts</em> Near You
            </h1>
            <p className="hero-desc">
              AfreXpert bridges the gap between talented professionals and clients who need quality services — fast, reliable, and trusted.
            </p>
            <div className="hero-actions">
              <a href="https://apps.apple.com" className="store-btn apple" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" /></svg>
                <span><small>Download on</small>App Store</span>
              </a>
              <a href="https://play.google.com" className="store-btn google" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.37.21.8.22 1.19.04l13.07-7.42-2.82-2.83-11.44 10.21zm16.57-10.73L17 11.46l-2.85 2.55 2.85 2.55 2.77-1.6c.79-.46.79-1.53-.02-1.93zM3.08.27C2.7.49 2.44.89 2.44 1.4v21.2c0 .51.26.91.64 1.13l12.22-11.73L3.08.27zm10.95 10.14L3.18.27 16.32 7.7l-2.29 2.71z" /></svg>
                <span><small>Get it on</small>Google Play</span>
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="app-preview">
                  <div className="app-header">
                    <div className="app-search-bar">🔍 Find a service...</div>
                  </div>
                  <div className="app-cards">
                    <div className="app-card"><span>⚡</span> Electrician</div>
                    <div className="app-card"><span>🔧</span> Plumber</div>
                    <div className="app-card"><span>🪚</span> Carpenter</div>
                    <div className="app-card featured"><span>🧹</span> Cleaner <span className="badge-new">Top</span></div>
                  </div>
                  <div className="app-profile">
                    <div className="profile-avatar">KD</div>
                    <div>
                      <div className="profile-name">Kwaku Kennedy</div>
                      <div className="profile-stars">★★★★★</div>
                    </div>
                    <div className="profile-btn">Book</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="floating-card card-1">✅ Booking Confirmed!</div>
            <div className="floating-card card-2">⭐ 4.9 Rating</div>
          </div>
        </div>
        {/* Stats */}
        <div className="container">
          <div className="stats-bar">
            {stats.map((s, i) => (
              <div key={i} className="stat-item">
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="benefits-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Why AfreXpert</span>
            <h2 className="section-title">Everything you need, in one app</h2>
            <p className="section-desc">We built AfreXpert to make professional services accessible, reliable, and stress-free for everyone.</p>
          </div>
          <div className="benefits-grid">
            {benefits.map((b, i) => (
              <div key={i} className="benefit-card" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="benefit-icon">{b.icon}</div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="cta-banner">
        <div className="container cta-inner">
          <div>
            <h2>Ready to get started?</h2>
            <p>Join thousands of clients and professionals on AfreXpert today.</p>
          </div>
          <div className="cta-actions">
            <Link to="/how-it-works" className="btn-white">See How It Works</Link>
            <Link to="/contact" className="btn-outline-white">Get in Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
